module.exports = __webpack_public_path__ + "img/succesful_txn_count.7a90c572.svg";